module.exports = __webpack_public_path__ + "img/kata-viktor.ee208aba.jpg";